// Catálogo de módulos y planes (espejo del backend src/config/modulos.js).
// Se usa en el panel Super Admin para administrar los módulos por empresa.
export const MODULOS = [
  { key: 'dashboard',     label: 'Dashboard' },
  { key: 'clientes',      label: 'Clientes' },
  { key: 'productos',     label: 'Productos' },
  { key: 'cotizaciones',  label: 'Cotizaciones' },
  { key: 'proyectos',     label: 'Proyectos y OT' },
  { key: 'taller',        label: 'Taller' },
  { key: 'compras',       label: 'Compras' },
  { key: 'facturacion',   label: 'Facturación' },
  { key: 'pos',           label: 'Punto de Venta (POS)' },
  { key: 'recepcion',     label: 'Facturas recibidas' },
  { key: 'nomina',        label: 'Nómina' },
  { key: 'rh',            label: 'Recursos Humanos' },
  { key: 'sgsst',         label: 'SG-SST' },
  { key: 'contabilidad',  label: 'Contabilidad' },
  { key: 'reportes',      label: 'Reportes' },
  { key: 'configuracion', label: 'Configuración' },
  { key: 'usuarios',      label: 'Usuarios y perfiles' },
  { key: 'cms_web',       label: 'Gestor Web (CMS)' },
];

// Módulos siempre activos (no se pueden quitar).
export const MODULOS_CORE = ['dashboard', 'configuracion', 'usuarios'];

// Presets de plan → módulos (además de los CORE).
export const PLANES = {
  basico: { nombre: 'Básico', modulos: ['clientes', 'productos', 'cotizaciones', 'facturacion', 'reportes'] },
  pro:    { nombre: 'Pro',    modulos: ['clientes', 'productos', 'cotizaciones', 'proyectos', 'compras', 'facturacion', 'recepcion', 'contabilidad', 'reportes'] },
  full:   { nombre: 'Full',   modulos: MODULOS.map(m => m.key) },
};

export function modulosDePlan(plan) {
  const base = (PLANES[plan] || PLANES.full).modulos;
  return Array.from(new Set([...MODULOS_CORE, ...base]));
}
